import * as types from '../mutationTypes'

let state = {
    loadingIndicator: false
}

const getters = {
    loadingIndicator (state) {
        return state.loadingIndicator
    }
}

const actions = {
    enableLoadingIndicator ({ commit }) {
        commit(types.ENABLE_LOADING_INDICATOR)
    },
    disableLoadingIndicator ({ commit }) {
        commit(types.DISABLE_LOADING_INDICATOR)
    }
}

const mutations = {
    [types.ENABLE_LOADING_INDICATOR] (state) {
        state.loadingIndicator = true
    },
    [types.DISABLE_LOADING_INDICATOR] (state) {
        state.loadingIndicator = false
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
